import { AccountId } from '@ply-io/ply-front-shared-utilities';

import { buildCrud, api } from './clients';

const WORKSPACE_DOMAINS_ENDPOINT = 'account-email-domains';

export type AccountEmailDomainId = number;

export type AccountEmailDomainResponse = {
	id: AccountEmailDomainId;
	account: AccountId;
	domain: string;
	verified: boolean;
	dkim: string;
	spf: string;
	list_of_allowed_emails: string[];
	return_path_domain: string;
	postmark_domain_id: string;
};

export type AccountEmailDomainPayload = Omit<
	AccountEmailDomainResponse,
	'id' | 'account' | 'verified' | 'dkim' | 'spf' | 'return_path_domain' | 'postmark_domain_id' | 'list_of_allowed_emails'
> & {
	list_of_allowed_emails: AccountEmailDomainResponse['list_of_allowed_emails'];
	return_path_domain?: AccountEmailDomainResponse['return_path_domain'];
};

const verifyDkim = async (id: AccountEmailDomainId): Promise<AccountEmailDomainResponse> =>
	await api.post(`${WORKSPACE_DOMAINS_ENDPOINT}/${String(id)}/verify_dkim/`);

const sendVerifyReplyToEmail = async (email: string): Promise<AccountEmailDomainResponse> =>
	await api.post('accounts/emails/send/', { email_to_verify: email });

const verifyReplyToEmailOtp = async (otp: number): Promise<AccountEmailDomainResponse> =>
	await api.post('accounts/emails/verify/', { otp });

export const useAccountEmailDomainCrud = () => {
	const {
		get,
		list,
		create,
		partialUpdate,
		delete: deleteMethod,
	} = buildCrud<AccountEmailDomainId, AccountEmailDomainPayload, AccountEmailDomainResponse>(api, WORKSPACE_DOMAINS_ENDPOINT);
	return { get, list, partialUpdate, create, deleteMethod, verifyDkim, sendVerifyReplyToEmail, verifyReplyToEmailOtp };
};
